import Vue from "vue";
import Router from "vue-router";
import auth from "@/auth/authService";
import i18n from "@/i18n/i18n";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL, 
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "",
            component: () => import("@/layouts/full-page/MainAuth.vue"),
            children: [
                {
                    path: "/",
                    name: "dashboard",
                    component: () => import("@/views/pages/Home.vue"),
                    meta: {
                        hideTitleOnPage: true,
                        rule: "~",
                        pageTitle: 'PagesHome'
                    }
                },
            ],
        },
        {
            path: "",
            component: () => import("@/layouts/full-page/Portal.vue"),
            children: [
                {
                    path: "/login/:project?",
                    name: "login",
                    component: () => import("@/views/pages/Login.vue"),
                    meta: {
                        rule: "*",
                        isLoginPage: true
                    }
                },
                {
                    path: "/forgot/staff",
                    name: "forgot_staff",
                    component: () => import("@/views/forms/login/ForgotStaff.vue"),
                    meta: {
                        nonAuth: true,
                        rule: "*",
                        pageTitle: 'ForgotPageTitle' 
                    }
                },
                {
                    path: "/forgot/student",
                    name: "forgot_student",
                    component: () => import("@/views/forms/login/ForgotStudent.vue"),
                    meta: {
                        nonAuth: true,
                        rule: "*",
                        pageTitle: 'ForgotPageTitleForStudent' 
                    }
                }, 
                {
                    path: "/find/student/mail",
                    name: "find_student_mail",
                    component: () => import("@/views/forms/find/FindMailStudent.vue"),
                    meta: {
                        nonAuth: true,
                        rule: "*",
                        pageTitle: 'FindMailPageTitleForStudent' 
                    }
                }, 
                {
                    path: "/not-authorized",
                    name: "autherror",
                    component: () => import("@/views/pages/NotAuthorized.vue"),
                    meta: {
                        rule: "*"
                    }
                }, {
                    path: "/not-found",
                    name: "notfound",
                    component: () => import("@/views/pages/Error404.vue"),
                    meta: {
                        rule: "*"
                    }
                }, {
                    path: "/maintenance",
                    name: "maintenance",
                    component: () => import("@/views/pages/Maintenance.vue"),
                    meta: {
                        rule: "*"
                    }
                }
            ]
        }, {
            path: "*",
            redirect: to => ({
                name: "login",
                params: {
                    project: to.path.replace("/", ""),
                },
                query: { form: to.query.form },
              })
        }
    ]
});

router.afterEach(() => {

    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {
    try{
        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.pageTitle);
        if (nearestWithTitle) {
            var title = i18n.messages[i18n.locale][nearestWithTitle.meta.pageTitle];
            if (title)
                document.title = title + ' | ' + i18n.messages[i18n.locale].PageTitle;
            else
                document.title = i18n.messages[i18n.locale].PageTitle;
        } else {
            document.title = i18n.messages[i18n.locale].PageTitle;
        }
    }
    catch{}

    const pageRule = to.meta.rule;
    const isLoginPage = to.meta.isLoginPage;
    const nonAuth = to.meta.nonAuth;

    if (pageRule && auth.isFullAuthenticated() && !auth.hasUserRole(pageRule))
        return router.push("/not-authorized");
    else if (pageRule && !auth.isFullAuthenticated() && !isLoginPage && !nonAuth)
        return router.push("/login");

    // if (auth.isAuthenticated() && isLoginPage)
    //     window.location.href = "https://www.fsm.edu.tr";

    return next();
});

export default router;
